import API from './api'

export default class Favs {
  constructor() {
    document.addEventListener('click', (event) => {
      const element = event.target

      if (
        element.classList.contains('is-fav') &&
        !element.classList.contains('is-inactive')
      ) {
        // element.classList.add('is-loading')

        API.toggleFav(element.dataset.fav, element.dataset.id)
          .then(() => {
            document
              .querySelectorAll('.is-fav[data-id="' + element.dataset.id + '"]')
              .forEach((element) => {
                this.toggleButton(element, element.dataset.fav)
              })
          })
          .finally(() => {
            // element.classList.remove('is-loading')
          })
      }
    })
  }

  toggleButton(element, state) {
    if (state) {
      element.removeAttribute('data-fav')

      if (element.classList.contains('is-primary')) {
        element.classList.add('is-black')
        element.classList.remove('is-primary')
      }

      if (element.classList.contains('is-on')) {
        element.classList.add('is-off')
        element.classList.remove('is-on')
      }
    } else {
      element.setAttribute('data-fav', 'true')

      if (element.classList.contains('is-black')) {
        element.classList.add('is-primary')
        element.classList.remove('is-black')
      }

      if (element.classList.contains('is-off')) {
        element.classList.add('is-on')
        element.classList.remove('is-off')
      }
    }
  }
}
